module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/babel-runtime/core-js/object/define-property.js
// module id = ../../../../babel-runtime/core-js/object/define-property.js
// module chunks = 3